import { SimpleFormValidationConfig, requiredValidation } from 'app/infrastructure/simple-form';
import { sfNames } from 'app/area/administration/edit/sf-names';

export const requiredFields = [sfNames.personId, sfNames.name];
export const editRoleValidationConfig: SimpleFormValidationConfig = requiredFields.map(field => requiredValidation(field));
